// Base paths for the shared Beaumont-portals.com backend. In development,
// CRA's `proxy` field in package.json forwards these to the backend running
// on http://localhost:5600 (same backend the main staff/admin app talks to).
// In production this app is served from agency.beaumont-portals.com and
// talks to the same API host as the main app — same registrable domain, so
// the `agencyJwt` cookie (SameSite=Strict) round-trips correctly.
export const AGENCY_URL = '/api/agencies';
export const AGENCY_SHIFTS_URL = '/api/agency/shifts';
